import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=06210fba&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06210fba')) {
      api.createRecord('06210fba', component.options)
    } else {
      api.reload('06210fba', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=06210fba&", function () {
      api.rerender('06210fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pvE3tCw0uXYr/JS/comp/ImgFallback.vue"
export default component.exports